var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 31.0175H12.5C5.25996 31.0175 2.16663 27.9242 2.16663 20.6842V12.6842C2.16663 5.44416 5.25996 2.35083 12.5 2.35083H20.5C27.74 2.35083 30.8333 5.44416 30.8333 12.6842V20.6842C30.8333 27.9242 27.74 31.0175 20.5 31.0175ZM12.5 4.35083C6.35329 4.35083 4.16663 6.5375 4.16663 12.6842V20.6842C4.16663 26.8308 6.35329 29.0175 12.5 29.0175H20.5C26.6466 29.0175 28.8333 26.8308 28.8333 20.6842V12.6842C28.8333 6.5375 26.6466 4.35083 20.5 4.35083H12.5Z",
    fill: "#0033CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.82 22.3907C14.5667 22.3907 14.3134 22.2974 14.1134 22.0974C13.7267 21.7107 13.7267 21.0707 14.1134 20.684L18.1134 16.684L14.1134 12.684C13.7267 12.2974 13.7267 11.6574 14.1134 11.2707C14.5 10.884 15.14 10.884 15.5267 11.2707L20.2334 15.9774C20.62 16.364 20.62 17.004 20.2334 17.3907L15.5267 22.0974C15.3267 22.2974 15.0734 22.3907 14.82 22.3907Z",
    fill: "#0033CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveRight);
export default __webpack_public_path__ + "static/media/move-right.316f44ee92a5eb97ac873a2c726f5d19.svg";
export { ForwardRef as ReactComponent };